/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Legal_PrefixInputs */

const en_auth_legal_prefix = /** @type {(inputs: Auth_Legal_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By continuing, you agree to the`)
};

/**
* | output |
* | --- |
* | "By continuing, you agree to the" |
*
* @param {Auth_Legal_PrefixInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_legal_prefix = /** @type {((inputs?: Auth_Legal_PrefixInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Legal_PrefixInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_legal_prefix(inputs)
});